export const SETTINGS_TABS = [
  { id: "company", label: "Company Info" },
  { id: "locations", label: "Office Locations" },
  { id: "reminders", label: "Reminders" },
  // { id: "notifications", label: "Notifications" },
  // { id: "workflow", label: "Workflow" },
  { id: "billing", label: "Billing" },
  { id: "license", label: "License Info", roles: ["owner"] },
  // { id: "rooms", label: "Room Requirement" },
  { id: "termsInfo", label: "Terms & conditions" },
];

export const DEFAULT_COMPANY_INFO = {
  name: "Venus Infra Services",
  email: "info@venusinfra.com",
  phone: "+91 9800000000",
  address: "Hyderabad, Telangana",
  gst: "36ABCDE1234F1Z5",
  website: "www.venusinfraservices.com",
};
